import React, { useEffect, useState } from "react";

import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";

import S6_Footer from "../S6_Footer";
// import Loading from "./loading";

const VideoBK = styled.video`
  height: auto;
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;
const Wrapper = styled.div`
  padding: 10px 0;
`;
// const VideoPlay = styled.video`
//   height: auto;
//   display: block;
//   object-fit: cover;
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   z-index: 1;
// `;
const Index = () => {
  // const [useLoader, setLoader] = useState(true);
  // setLoader(false);
  useEffect(() => {
    const timer = setTimeout(() => console.log("Hello, ssssssWorld!"), 3000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      {/* <VideoPlay autoPlay>
        <source src="/images/hapevideo.mp4" type="video/mp4" />
      </VideoPlay> */}
      {/* {useLoader ? <Loading /> : <span />} */}
      <VideoBK autoPlay loop muted>
        <source src="/images/hapebg.mp4" type="video/mp4" />
      </VideoBK>
      <Menu />
      <SectionWrapper></SectionWrapper>
      <S6_Footer />
    </div>
  );
};

export default Index;
